import { isAndroidApp } from '$func/environmentInfo'
import {
  setTwaHttpServerPort,
  setTwaWsServerUrl,
} from '$logic/twaCommunication'
import { SessionStorageKeys } from '$logic/client-device/types'
import { sessionStorageGetItem } from '$func/session-storage'

if (isAndroidApp) {
  const wsUrl = sessionStorageGetItem(SessionStorageKeys.TWA_WS_URL)
  if (wsUrl) setTwaWsServerUrl(wsUrl)
  else {
    const port = sessionStorageGetItem(SessionStorageKeys.TWA_PORT)
    if (port) setTwaHttpServerPort(port)
  }
}
